import PropertyDataListItem from './PropertyDataListItem';

export default PropertyDataListItem;
